ACC.addressDoctorHED = {
    editedRecommendedAddress: true,
    elements: {
        hidden: 'hidden',
        ADClassWrapper: '.js-address-doctor',
        reenterADClassWrapper: '.js-reenter-address-doctor',
        reenterADBtnClass: '.js-btn-reenter-address',
        recommendedADBtnClass: '.js-btn-recommended-address',
        descriptionOfMoreThanOneOptionClass: '.js-description-of-more-than-one-option',
        descriptionOfOneOptionClass: '.js-description-of-one-option',
    },

    bindOriginalAddressTemplateEvents(nextStep = () => {}) {
        const { showAddressDoctorBlock, showReenterAddressDoctorBlock, handlerChange } = ACC.addressDoctorHED;
        const originalAddressBtn = document.querySelector('.js-btn-original-address');
        originalAddressBtn.addEventListener('click', () => {
            showAddressDoctorBlock(false);
            showReenterAddressDoctorBlock(false);
            ACC.addressDoctorHED.editedRecommendedAddress = false;
            handlerChange();
            nextStep();
        });
    },

    fetchAddressDoctor(form) {
        const { getDataFromUserForm } = ACC.addressDoctorHED;
        const url = `${ACC.config.encodedContextPath}/address/verify`;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                CSRFToken: ACC.config.CSRFToken,
            },
            body: JSON.stringify(getDataFromUserForm(form)),
        };
        return fetch(url, options).then((response) => {
            if (!response.ok) { throw response; }
            return response.json();
        });
    },

    setDataToUserForm(data, component) {
        component.find($('#address\\.country'))
            .val((data.region && data.region.countryIso) || (data.country && data.country.isocode));
        component.find($('#address\\.firstName')).val(data.firstName);
        component.find($('#address\\.surname')).val(data.lastName);
        component.find($('#address\\.line1')).val(data.line1);
        component.find($('#address\\.line2')).val(data.line2);
        component.find($('#address\\.townCity')).val(data.town);
        component.find($('#address\\.region')).val(data.region && data.region.isocodeShort);
        component.find($('#address\\.postcode')).val(data.postalCode);
        component.find($('#address\\.phone')).val(data.phone);
    },

    handlerChange() {
        const inputsArr = [
            $('#address\\.country')[0],
            $('#address\\.line1')[0],
            $('#address\\.line2')[0],
            $('#address\\.townCity')[0],
            $('#address\\.region')[0],
            $('#address\\.postcode')[0],
        ].filter((input) => input); // remove undefined

        inputsArr.map((item) => item.addEventListener('change', () => {
            ACC.addressDoctorHED.editedRecommendedAddress = true;
        }));
    },

    getDataFromUserForm(component) {
        const newCardRadioBtn = document.querySelector('#savedCard-newCard');
        const savedCardBillingAddress = ACC.unifiedWallet.billingAddress;
        const collectedData = {};

        if (newCardRadioBtn && !newCardRadioBtn.checked) {
            collectedData.countryIso = savedCardBillingAddress.billTo_country;
            collectedData.firstName = savedCardBillingAddress.billTo_firstName;
            collectedData.lastName = savedCardBillingAddress.billTo_lastName;
            collectedData.line1 = savedCardBillingAddress.billTo_street1;
            collectedData.line2 = savedCardBillingAddress.billTo_street2 || '';
            collectedData.townCity = savedCardBillingAddress.billTo_city;
            collectedData.postcode = savedCardBillingAddress.billTo_postalCode;
            collectedData.phone = savedCardBillingAddress.billTo_phoneNumber;
            collectedData.regionIso = (savedCardBillingAddress.billTo_state
                && savedCardBillingAddress.billTo_state.substring(3));
        } else {
            collectedData.countryIso = component.find($('#address\\.country')).val();
            collectedData.firstName = component.find($('#address\\.firstName')).val();
            collectedData.lastName = component.find($('#address\\.surname')).val();
            collectedData.line1 = component.find($('#address\\.line1')).val();
            collectedData.line2 = component.find($('#address\\.line2')).val();
            collectedData.townCity = component.find($('#address\\.townCity')).val();
            collectedData.postcode = component.find($('#address\\.postcode')).val();
            collectedData.phone = ACC.phonemasking.collectPhoneNumber(component.find($('#address\\.phone')));
            collectedData.regionIso = component.find($('#address\\.region')).val();
        }
        return collectedData;
    },

    setRecommendedAddresses(data) {
        const numberOfProposedOptions = data.length;
        ACC.addressDoctorHED.showCorrespondingDescriptionInlineAddressDoctor(numberOfProposedOptions);
        const dataWithId = data.map((item, index) => ({ ...item, id: index }));
        $('.js-recommended-address-doctor-container').html($('#recommendedAddressDoctorTemplate').tmpl(dataWithId));
    },

    setOriginalAddresses(data) {
        $('.js-original-address-doctor-container').html($('#originalAddressDoctorTemplate').tmpl(data));
    },

    setReenterAddress(data) {
        $('.js-reenter-address-doctor-container').html($('#reenterAddressDoctorTemplate').tmpl(data));
    },

    showAddressDoctorBlock(show) {
        const { hidden, ADClassWrapper, reenterADClassWrapper } = ACC.addressDoctorHED.elements;
        const wrapper = document.querySelector(ADClassWrapper);
        const reenterWrapper = document.querySelector(reenterADClassWrapper);
        if (show) {
            reenterWrapper.classList.add(hidden);
            wrapper.classList.remove(hidden);
        } else {
            wrapper.classList.add('hidden');
        }
    },

    showCorrespondingDescriptionInlineAddressDoctor(numberOfProposedOptions) {
        // eslint-disable-next-line max-len
        const { hidden, descriptionOfMoreThanOneOptionClass, descriptionOfOneOptionClass } = ACC.addressDoctorHED.elements;
        const descriptionOfMoreThanOneOptionWrapper = document.querySelector(descriptionOfMoreThanOneOptionClass);
        const descriptionOfOneOptionWrapper = document.querySelector(descriptionOfOneOptionClass);
        if (numberOfProposedOptions === 1) {
            descriptionOfMoreThanOneOptionWrapper.classList.add(hidden);
            descriptionOfOneOptionWrapper.classList.remove(hidden);
        } else {
            descriptionOfMoreThanOneOptionWrapper.classList.remove(hidden);
            if (!descriptionOfOneOptionWrapper.classList.contains(hidden)) {
                descriptionOfOneOptionWrapper.classList.add(hidden);
            }
        }
    },

    showReenterAddressDoctorBlock(show) {
        const { hidden, ADClassWrapper, reenterADClassWrapper } = ACC.addressDoctorHED.elements;
        const wrapper = document.querySelector(ADClassWrapper);
        const reenterWrapper = document.querySelector(reenterADClassWrapper);
        if (show) {
            wrapper.classList.add(hidden);
            reenterWrapper.classList.remove(hidden);
        } else {
            reenterWrapper.classList.add(hidden);
        }
    },

    fillExpDateNewCreditCardForm(savedCardId) {
        const { getExpirationDateFromSelectedCard } = ACC.addressDoctorHED;
        const { validToMonth, validToYear } = getExpirationDateFromSelectedCard(savedCardId);
        const event = new Event('change');
        const inputs = document.querySelectorAll('#newCreditCardFormId input, #newCreditCardFormId select');
        const newCreditCard = ['card_accountNumber', 'ExpiryMonth', 'ExpiryYear', 'card_cvNumber'];

        inputs.forEach((input) => {
            if (newCreditCard.includes(input.id)) {
                switch (input.id) {
                case 'ExpiryYear':
                    input.value = validToYear || '';
                    break;
                case 'ExpiryMonth':
                    input.value = validToMonth || '';
                    break;
                default: input.value = '';
                }
                input.dispatchEvent(event);
            }
        });
    },

    clearNewCreditCardForm() {
        const inputs = document.querySelectorAll('#newCreditCardFormId input, #newCreditCardFormId select');
        if (inputs) {
            inputs.forEach((input) => {
                input.value = '';
            });
        }
    },
    // paymentId: number
    getExpirationDateFromSelectedCard(paymentId) {
        const paymentData = GLOBAL_PAYMENT_DATA.find((el) => el.paymentId === paymentId);

        return paymentData && {
            validToMonth: paymentData.validToMonth,
            validToYear: paymentData.validToYear,
        };
    },

    isInlineAddressDoctorEnabled() {
        const {
            isAddressDoctorInlineBillingEnabledLearner,
            isAddressDoctorInlineBillingEnabledLearnerCA,
            isAddressDoctorInlineBillingEnabledLearnerUK,
        } = ACC.config;

        return isAddressDoctorInlineBillingEnabledLearner
            || isAddressDoctorInlineBillingEnabledLearnerCA
            || isAddressDoctorInlineBillingEnabledLearnerUK;
    },
};
